import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function EditorDeTexto({ onChange, value }) {
  return (
    <ReactQuill
      value={value}
      onChange={onChange}
      modules={{
        toolbar: [
          [{ 'header': '1' }, { 'header': '2' }],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          ['bold', 'italic', 'underline'],
          ['link'],
        ],
      }}
    />
  );
}

export default EditorDeTexto;
